import CONFIG from "@/assets/js/config.js";

const staff = CONFIG.ROLE.ID.STAFF;
const accountant = CONFIG.ROLE.ID.ACCOUNTANT;
const library_admin = CONFIG.ROLE.ID.LIBRARY_ADMIN;
const class_monitor = CONFIG.ROLE.ID.CLASS_MONITOR;

const ACCESS_CONTROL = {
    PERIOD: {
        create: [staff],
        edit: [staff],
    },
    GRADE: {
        create: [staff],
        edit: [staff],
    },
    HOLIDAY: {
        create: [staff],
        edit: [staff],
        delete: [staff],
        import: [staff],
    },
    GRADING_SETTING: {
        create: [staff],
        edit: [staff],
        delete: [staff],
    },
    APP_FORM: {
        create: [staff],
        edit: [staff],
        delete: [staff],
    },
    TIMETABLE_META: {
        create: [staff],
        edit: [staff],
        delete: [staff],
    },
    TEACHER_TYPE: {
        create: [staff],
        edit: [staff],
        delete: [staff],
    },
    PAYMENT_METHOD: {
        create: [staff, accountant],
        edit: [staff, accountant],
        delete: [staff, accountant],
    },
    GRADE_FEE: {
        create: [staff, accountant],
        edit: [staff, accountant],
        delete: [staff, accountant],
        import: [staff, accountant],
    },
    ITEM: {
        create: [staff, accountant],
        edit: [staff, accountant],
        delete: [staff, accountant],
    },
    TRANSACTION_CATEGORY: {
        create: [staff, accountant],
        edit: [staff, accountant],
        delete: [staff, accountant],
    },
    CAMPUS_GRADE: {
        create: [staff],
        edit: [staff],
        delete: [staff],
        import: [staff],
    },
    CLASS: {
        create: [staff],
        edit: [staff],
        delete: [staff],
    },
    SUBJECT: {
        create: [staff],
        edit: [staff],
        import: [staff],
    },
    TIMETABLE: {
        create: [staff],
        edit: [staff],
        delete: [staff],
    },
    ADMIN: {
        create: [],
        edit: [staff],
        delete: [],
    },
    CAMPUS: {
        create: [],
        edit: [],
        delete: [],
    },
    TEACHER: {
        create: [staff],
        edit: [staff],
        delete: [staff],
        import: [staff],
    },
    STUDENT: {
        create: [staff],
        edit: [staff],
        delete: [staff],
        import: [staff],
        setResult: [staff],
        enrollment: [staff],
    },
    PARENT: {
        create: [staff],
        edit: [staff],
        delete: [staff],
        import: [staff],
    },
    APPLICANT: {
        setResult: [staff],
    },
    STUDENT_ATTENDANCE: {
        create: [staff, class_monitor],
        edit: [staff, class_monitor],
        delete: [staff, class_monitor],
    },
    STUDENT_LEAVE: {
        create: [staff, class_monitor],
        edit: [staff, class_monitor],
        delete: [staff, class_monitor],
    },
    TEACHER_ATTENDANCE: {
        create: [staff, accountant],
        edit: [staff, accountant],
        delete: [staff, accountant],
    },
    TEACHER_LEAVE: {
        create: [staff, accountant],
        edit: [staff, accountant],
        delete: [staff, accountant],
    },
    SUBJECT_TEACHER: {
        create: [staff],
        edit: [staff],
        delete: [staff],
        import: [staff],
    },
    COURSE: {
        create: [staff],
        edit: [staff],
        delete: [staff],
    },
    ASSIGNMENT: {
        create: [staff],
        edit: [staff],
        delete: [staff],
    },
    EXAM: {
        create: [staff],
        edit: [staff],
        delete: [staff],
    },
    GRADING: {
        create: [staff],
        edit: [staff],
        delete: [staff],
        import: [staff],
    },
    NOTICE: {
        create: [staff],
        edit: [staff],
        delete: [staff],
    },
    CHAT_REQUEST: {
        approve: [staff],
        reject: [staff],
    },
    PAYMENT: {
        create: [accountant],
        edit: [accountant],
        delete: [accountant],
        sendNoti: [accountant],
    },
    PAYMENT_HISTORY: {
        create: [accountant],
        edit: [accountant],
        delete: [accountant],
        showForm: [accountant],
        approve: [accountant],
        reject: [accountant],
    },
    TRANSACTION: {
        create: [accountant],
        edit: [accountant],
        delete: [accountant],
    },
    SALARY: {
        create: [accountant],
        edit: [accountant],
        delete: [accountant],
    },

    PAYMENT_METHOD_BALANCE: {
        finalize: [accountant],
    },

    HOSTEL: {
        create: [staff],
        edit: [staff],
        delete: [staff],
    },
    DRIVER: {
        create: [staff],
        edit: [staff],
        delete: [staff],
    },
    FERRY: {
        create: [staff],
        edit: [staff],
        delete: [staff],
    },
    ROUTE: {
        create: [staff],
        edit: [staff],
        delete: [staff],
    },
    ROUTE_POINT: {
        create: [staff],
        edit: [staff],
        delete: [staff],
    },
    FERRY_PICKUP: {
        edit: [staff],
        delete: [staff],
    },
    DAILY_FERRY: {
        create: [staff],
        edit: [staff],
        delete: [staff],
    },
    CATEGORY: {
        create: [staff, library_admin],
        edit: [staff, library_admin],
        delete: [staff, library_admin],
    },
    BOOK: {
        create: [staff, library_admin],
        edit: [staff, library_admin],
        delete: [staff, library_admin],
        import: [staff, library_admin],
    },
    LIBRARY_MEMBER: {
        create: [staff, library_admin],
        edit: [staff, library_admin],
        delete: [staff, library_admin],
    },
    CHECKOUT: {
        create: [staff, library_admin],
        edit: [staff, library_admin],
        delete: [staff, library_admin],
        cancel: [staff, library_admin],
    },
    DAMAGE_LOSSES: {
        create: [staff, library_admin],
        edit: [staff, library_admin],
        delete: [staff, library_admin],
    },
};

export default ACCESS_CONTROL;
